import { MDBBadge, MDBIcon } from "mdbreact";
import React from "react";
import images from "../../../assets/img/app";
import { Recommend } from "../../../containers/StampCard";
import classes from "./TenantSelectElement.module.scss";

/**
 * テナント選択スタンププロパティ
 */
type TenantSelectElementProps = {
  /** スタンプID */
  id: string;
  /** 選択状態 */
  isChecked?: boolean;
  /** 強調するか */
  isEmphasize?: boolean;
  /** スタンプ画像URL */
  image: string;
  /** テナント名 */
  name: string;
  /** クリックイベント */
  onClick: (tenant: Recommend) => void;
};

/**
 * テナント選択スタンプコンポーネント
 * @param props テナント選択スタンププロパティ
 */
const TenantSelectElement: React.FC<TenantSelectElementProps> = (props) => {
  return (
    <React.Fragment>
      <div
        className={`position-relative ${
          props.isEmphasize && !props.isChecked ? `${classes.emphasize}` : ""
        }`}
        onClick={() =>
          props.onClick({
            id: props.id,
            image: props.image,
            name: props.name,
          })
        }
      >
        <img
          className={`img-fluid ${classes.tenantImage} ${
            props.isChecked ? "z-depth-2" : `${classes.unchecked} z-depth-1`
          }`}
          src={props.image}
          alt=""
        />
        {props.isChecked ? (
          <MDBBadge pill color="pink" className={`${classes.checkedBadge} p-2`}>
            <MDBIcon icon="check" />
          </MDBBadge>
        ) : null}
        {props.isEmphasize && !props.isChecked ? (
          <img
            className={`img-fluid ${classes.emphasizeBadge}`}
            src={images.emphasizeBadge}
            alt=""
          />
        ) : null}
      </div>
      <div className={`mt-2 ${classes.tenantName}`}>{props.name}</div>
    </React.Fragment>
  );
};

export default TenantSelectElement;
